import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../css/login.css';
import logo from '../image/logo.png';
import test1 from '../image/judge-3.gif';
import { sendEmailAndVerify } from '../services/VerificationCode_service';

const VerificationCode: React.FC = () => {
    const [code, setCode] = useState<string[]>(['', '', '', '']);
    const [generatedCode, setGeneratedCode] = useState<string>('');
    const [emailSent, setEmailSent] = useState<boolean>(false); // Drapeau pour vérifier si l'e-mail a été envoyé
    const navigate = useNavigate();
    const email = localStorage.getItem('email') || '';

    // Fonction pour générer un code aléatoire de 4 chiffres
    const generateRandomCode = (): string => {
        let randomCode = '';
        for (let i = 0; i < 4; i++) {
            randomCode += Math.floor(Math.random() * 10).toString();
        }
        return randomCode;
    };

    useEffect(() => {
        if (!generatedCode) {
            const randomCode = generateRandomCode();
            setGeneratedCode(randomCode);
        }

        // Envoyer le code par e-mail si ce n'est pas encore fait
        if (!emailSent && generatedCode) {
            const sendVerificationCode = async () => {
                try {
                    await sendEmailAndVerify(email, generatedCode);
                    setEmailSent(true); // Marquer que l'e-mail a été envoyé
                } catch (error) {
                    console.error('Erreur lors de l\'envoi de l\'e-mail:', error);
                    toast.error('Erreur lors de l\'envoi du code par e-mail');
                }
            };

            sendVerificationCode();
        }
    }, [email, generatedCode, emailSent]);

    // Fonction pour gérer les changements dans les champs du code
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const value = e.target.value;
        if (/^[0-9]?$/.test(value)) {
            const newCode = [...code];
            newCode[index] = value;
            setCode(newCode);

            if (value !== '' && index < 3) {
                (document.getElementById(`code-${index + 1}`) as HTMLInputElement)?.focus();
            }
        }
    };

    // Fonction pour gérer la soumission du formulaire
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const codeString = code.join('');

        if (codeString !== generatedCode) {
            toast.error('Code invalide');
            return;
        }

        try {
            toast.success('Code validé avec succès !');
            navigate('/password');
        } catch (error) {
            toast.error('Erreur lors de la vérification du code');
        }
    };

    return (
        <>
            <ToastContainer />
            <div className="degrade-vertical big-height">
               {/* logo */}
                <div className="row  col-section d-flex justify-content-center align-items-center vh-100">
                    <div className="col-md-6 col-sm-12 d-flex section-txt mt-5">
                    <div className="bg-section section-tab my-5">
                            <div className="img-animate">
                                <img src={test1} alt="png" className="img-fluid w-100 ImgGif" />
                            </div>
                            <div className="text-title  ">
                                <h1 className="font-1">Annonce Legale <br /> Officielle</h1>
                                <p className="font-2 ">Bénéficiez d’une publication instantanée dans toute la France,
                                    grâce à notre plateforme sécurisée en ligne, disponible 24/7 et adaptée à tout type
                                    d’annonce, des plus simples aux plus complexes.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12 d-flex  bg-verifiermail section-txt">
                        <div className="p-3">
                            <img src={logo} className="my-2 ml-3 logo-1" alt="logo" />
                        </div>
                        <form className="form-login pb-4 px-5 mx-auto pt-4 d-flex" onSubmit={handleSubmit}>
                            <p className="txt-login mb-4">Veuillez entrer le code que  <br /> <span className='txt-login'>vous avez reçu par e-mail</span></p>
                            <div className="input-group mb-3 verification-code-input">
                                {code.map((digit, index) => (
                                   <input
                                    key={index}
                                    id={`code-${index}`}
                                    type="text"
                                    className="form-control code-input"
                                    value={digit}
                                    onChange={(e) => handleChange(e, index)}
                                    maxLength={1}
                                    pattern="[0-9]"
                                    required
                                    />

                                ))}
                            </div>
                            <p className="error-message"></p>
                            <button type="submit" className="btn btn-1">Envoyer</button>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default VerificationCode;
